import React, {useEffect, useState} from 'react';
import { Form, Input, DatePicker } from 'antd';
import SPSelectWithApi from "../../../../../../components/product-price/base/SPSelectWithApi";
import moment from "moment/moment";
import {decryptTextByAES} from "../../../../../../utils/encryption";
import EnumKeyToText from "../../../../../product-price/base/EnumKeyToText";
import {formatTimeRange} from "../../../../../../utils/tool";
const { TextArea } = Input;

interface IComponentProps {
    data?: any;
    enums?: any
}

const DriverPlatoon: React.FC<IComponentProps> = (props) => {
    const { data, enums } = props
    const form = Form.useFormInstance();
    useEffect(() => {
        if (data?.pickup_driver_uid > 0) {
            form.setFieldsValue({
                pickup_uid: data?.pickup_driver_uid,
            })
        }
        if (data?.return_driver_uid > 0) {
            form.setFieldsValue({
                return_uid: data?.return_driver_uid,
            })
        }
    }, [data]);

    // @ts-ignore
    return (
        <>
            <Form.Item label={'订单编号'}>
                {data.order_code}
            </Form.Item>
            <Form.Item label={'取还时间'}>
                {`${formatTimeRange(data?.pickup_info?.time, data?.return_info?.time)}` }
            </Form.Item>
            <Form.Item  label={'预定车型'} >
                <div>{data?.veh_model_info?.brand_name}/{data?.veh_model_info?.series_name}/{data?.veh_model_info?.model_name}</div>

                <div>
                    {data.veh_model_info.group_code}
                    ｜ <EnumKeyToText data={data.veh_model_info} enums={enums} valueKey={'transmission_type'} nameSpace={'transmission_type'} />
                    ｜ <EnumKeyToText data={data.veh_model_info} enums={enums} valueKey={'fuel_type'} nameSpace={'fule_type'} />
                    ｜ {data.veh_model_info.passenger_no}座
                    ｜ {data.veh_model_info.door_no}门
                </div>
            </Form.Item>

            <Form.Item  label={'预定车辆'} >
                {decryptTextByAES(data.veh_info.veh_plate)}
            </Form.Item>
            {
                data.order_status === 1 ?
                    <Form.Item name={ 'pickup_uid' } label={'送车司机'} rules={[{required: true, message: '请选择送车司机'}]}>
                        <SPSelectWithApi
                            params={{
                                order_code: data.order_code,
                            }}
                            method={'get'}
                            resListPath='data.pickup_list'
                            labelKey='name'
                            valueKey='uid'
                            placeholder="请选择送车司机"
                            url={'/rental/scm/order/driver/list'}
                        ></SPSelectWithApi>
                    </Form.Item>
                    :
                    <Form.Item  label={'送车司机'} rules={[{required: true, message: '请选择送车司机'}]}>
                        <SPSelectWithApi
                            params={{
                                order_code: data.order_code,
                            }}
                            value={data?.pickup_driver_uid}
                            disabled
                            method={'get'}
                            resListPath='data.pickup_list'
                            labelKey='name'
                            valueKey='uid'
                            placeholder="请选择送车司机"
                            url={'/rental/scm/order/driver/list'}
                        ></SPSelectWithApi>
                    </Form.Item>
            }

            <Form.Item name={'return_uid'} label={'取车司机'} rules={[{required: true, message: '请选择取车司机'}]}>
                <SPSelectWithApi
                    params={{
                        order_code: data.order_code,
                    }}
                    method={'get'}
                    resListPath='data.return_list'
                    labelKey='name'
                    valueKey='uid'
                    placeholder="请选择取车司机"
                     url={'/rental/scm/order/driver/list'}
                ></SPSelectWithApi>
            </Form.Item>
            <Form.Item name={'remark'} label={'订单备注'} >
                <TextArea rows={4} showCount placeholder="请输入订单备注" maxLength={100} />
            </Form.Item>
        </>
    );
};

export default DriverPlatoon;
